import { Typography } from '@weareopenr/component-library';
import styles from './ModalTitle.module.scss';

export const ModalTitle = ({ title, subTitle }: { title: string; subTitle?: string }) => {
  return (
    <div className={styles['modal-title']}>
      <Typography size="xxlarge" weight="bold">
        {title}
      </Typography>
      {subTitle && <Typography size="medium">{subTitle}</Typography>}
    </div>
  );
};
